export const generateRequiredRule = (message = 'Required') => ({
  required: {
    value: true,
    message: message
  }
});

export const SUPPLIER_ACCREDITATION_BUSINESS_RULES = {
  abn_number: {
    ...generateRequiredRule('ABN is required'),
    maxLength: {
      value: 11, message: 'ABN must be 11 digits'
    },
    minLength: {
      value: 11, message: 'ABN must be 11 digits'
    }
  },
  applicants_count: {
    ...generateRequiredRule()
  },
  domain: {
    ...generateRequiredRule()
  },
  address: {
    ...generateRequiredRule()
  }
}

export const SUPPLIER_ACCREDITATION_PERSONAL_RULES = {
  first_name: {
    ...generateRequiredRule()
  },
  last_name: {
    ...generateRequiredRule()
  },
  work_phone: {
    ...generateRequiredRule()
  },
  dob: {
    ...generateRequiredRule()
  },
  email: {
    ...generateRequiredRule(),
    email: {
      value: true, message: 'Invalid email address'
    }
  },
  location: {
    ...generateRequiredRule()
  }
}

export const SUPPLIER_ACCREDITATION_INSTALLERS_RULES = {
  full_name: {
    ...generateRequiredRule()
  },
  licence_number: {
    ...generateRequiredRule()
  },
  installer_type: {
    ...generateRequiredRule()
  },
}

export const SUPPLIER_ACCREDITATION_EXPERIENCE_RULES = {
  installation_total: {
    ...generateRequiredRule()
  },
  kw_total: {
    ...generateRequiredRule()
  },
  installation_type: {
    ...generateRequiredRule()
  },
}

export const SUPPLIER_ACCREDITATION_LOGIN_RULES = {
  full_name: {
    ...generateRequiredRule()
  },
  phone_number: {
    ...generateRequiredRule()
  },
  email: {
    ...generateRequiredRule(),
    email: {
      value: true, message: 'Invalid email address'
    }
  },
}

export const SUPPLIER_ACCREDITATION_ACKNOWLEDGEMENT_RULES = {
  status: {
    ...generateRequiredRule()
  },
  acknowledgements_certified: {
    ...generateRequiredRule()
  },
}

export const APPLICATION_NOTES_RULES = {
  notes: {
    ...generateRequiredRule()
  },
}

export const INDIVIDUAL_RULES = {
  first_name: {
    ...generateRequiredRule()
  },
  last_name: {
    ...generateRequiredRule()
  },
  work_phone: {
    ...generateRequiredRule()
  },
  dob: {
    ...generateRequiredRule()
  },
  email: {
    ...generateRequiredRule(),
    email: {
      value: true, message: 'Invalid email address'
    }
  },
  location: {
    ...generateRequiredRule(),
  },
  driving_licence: {
    ...generateRequiredRule()
  },
  driving_licence_card: {
    ...generateRequiredRule()
  },
  marital_status: {
    ...generateRequiredRule()
  },
  gender: {
    ...generateRequiredRule()
  },
  applicant_address: {
    ...generateRequiredRule()
  },
}
export const INDIVIDUAL_RESIDENTIAL_RULES = {
  residency: {
    ...generateRequiredRule()
  },
  property_type: {
    ...generateRequiredRule()
  },
}

export const INDIVIDUAL_COMMERCIAL_RULES = {
  property_type: {
    ...generateRequiredRule()
  },
  is_other: {
    ...generateRequiredRule()
  },
  location: {
    ...generateRequiredRule()
  }
}

export const LOAN_RULES = {
  number_children: {
    ...generateRequiredRule(),
  },
  status: {
    ...generateRequiredRule(),
  },
}

export const INCOME_RULES = {
  is_primary_source: {
    ...generateRequiredRule(),
  },
  individual_id: {
    ...generateRequiredRule(),
  },
  status: {
    ...generateRequiredRule(),
  }
}

export const EXPENSES_RULES = {
  amount: {
    ...generateRequiredRule(),
  }
}

export const ASSETS_RULES = {
  amount: {
    ...generateRequiredRule(),
  }
}

export const UPLOAD_DOCUMENT_RULES = {
  status: {
    ...generateRequiredRule(),
  },
  document_type: {
    ...generateRequiredRule(),
  },
}

export const BASIC_RULES = {
  system_cost: {
    ...generateRequiredRule(),
  },
  term: {
    ...generateRequiredRule(),
  },
  applicants_count: {
    ...generateRequiredRule(),
  },
  system_cost_gst_status: {
    required: {
      value: false,
      message: ''
    }
  }
}

export const BUSINESS_RULES = {
  abn_number: {
    ...generateRequiredRule(),
    maxLength: {
      value: 11, message: 'ABN must be 11 digits'
    },
    minLength: {
      value: 11, message: 'ABN must be 11 digits'
    }
  },
  applicants_count: {
    ...generateRequiredRule(),
    max: {
      value: 2, message: 'Value must be 1 or 2'
    },
    min: {
      value: 1, message: 'Value must be 1 or 2'
    }
  },
  business_name: {
    ...generateRequiredRule(),
  },
  business_nature: {
    ...generateRequiredRule(),
  },
  applicant_type: {
    ...generateRequiredRule(),
  },
  business_ownership: {
    ...generateRequiredRule(),
  },
  address: {
    ...generateRequiredRule(),
  },
}

export const PRODUCT_RULES = {
  products_for_business_purposes: {
    ...generateRequiredRule(),
  },
  product_status: {
    ...generateRequiredRule(),
  },
  product_detail_fulfillment: {
    ...generateRequiredRule(),
  },
}

export const STOCK_FINANCE_BUSINESS_RULES = {
  abn_number: {
    ...generateRequiredRule('ABN is required'),
    maxLength: {
      value: 11, message: 'ABN must be 11 digits'
    },
    minLength: {
      value: 11, message: 'ABN must be 11 digits'
    }
  },
  applicants_count: {
    ...generateRequiredRule()
  },
  domain: {
    ...generateRequiredRule()
  },
  address: {
    ...generateRequiredRule()
  }
}
